<app-dashboard-card *ngIf="{ compactDesign: compactDesign$ | async } as tmpState" (onResize)="cardResize($event)"
  title="{{ title }}" [padding]="true">
  <ng-container cardHeaderRight>
    <cwc-picker #dateRangePicker *ngIf="!date && dateRanges" (cwcChange)="onDateRangeChange($event.detail)" unwrap
      variant="no-border" [placeholder]="datePlaceholder" [footerCancelButtonLabel]="pickerLabelCancel" required
      design-version="v2" label="{{datePlaceholder}}" id="cmx-dashboard-order-history-date-range-picker">
      <cwc-picker-option *ngFor="let opt of dateRanges; let i = index" [value]="opt" [selected]="i === 0">
        {{ opt.label }}
      </cwc-picker-option>
    </cwc-picker>
    <ng-content select="[slot='header-right']"></ng-content>
  </ng-container>
  <ng-container cardBody>
    <ng-container *ngIf="
        (loadingStatus$ | async) !== LoadingStatus.PENDING;
        else loadingState
      ">
      <cwc-grid [columns]="tmpState.compactDesign ? 1 : 5" [mobileColumns]="5"
        *ngIf="changeEmitter$ | async; else emptyResult">
        <cwc-cell [rowstart]="tmpState.compactDesign ? 2 : 1" #statusCell [colspan]="tmpState.compactDesign ? 1 : 3"
          class="list-content" (scroll)="trackScroll($event)" [ngClass]="{'onTopScroll': !scrolledToBottom  && enableInsetShadowList, 
                     'onMiddleScroll': !scrolledToBottom && !scrolletToTop && enableInsetShadowList, 
                     'onBottomScroll': scrolledToBottom && !scrolletToTop && enableInsetShadowList,
                     'center-content': !enableInsetShadowList,
                     'compact': tmpState.compactDesign }">

          <!-- For new design we need different approach to keep cell consistency -->
          <ng-container *ngIf="statuses$ | async as statuses">
            <div class="data-list" *ngIf="isNewDashboard2025Enabled && statuses[0] && statuses[0]?.balance">
              <div class="data-list-cell">
                <div class="data-list-heading">{{newDesignTranslation.documents}}</div>
              </div>
              <div class="data-list-cell">
                <div class="data-list-heading">{{newDesignTranslation.quantity}}</div>
              </div>
              <div class="data-list-cell">
                <div class="data-list-heading">{{newDesignTranslation.totalAmount}}</div>
              </div>

              <ng-container class="data-list-cell" *ngFor="let status of statuses">
                <div class="data-list-cell">
                  <cwc-status-indicator style=" width: min-content;" role=" status" [variant]="getStatusVariant(status)"
                    size="small" [outline]="status.outline">
                    <span class="list-item__status-label">{{ status.name }}</span>
                  </cwc-status-indicator>
                </div>
                <div class="data-list-cell">
                  {{ status.value }}&nbsp;{{ statusListItemOrdersLabel }}
                </div>
                <div class="data-list-cell">
                  <div style="white-space: nowrap;" *ngIf="status?.balance" [innerHtml]="status.balance | cmxCurrency">
                  </div>
                </div>
              </ng-container>
            </div>
            <ul #statusUl *ngIf="!isNewDashboard2025Enabled || !(statuses[0] && statuses[0]?.balance)">
              <ng-container *ngFor="let status of statuses; let first = first">
                <li class="list-item" *ngIf="first && status?.balance">
                  <div class="list-item__status">
                    <strong>{{newDesignTranslation.documents}}</strong>
                    <strong>{{newDesignTranslation.quantity}}</strong>
                    <strong>{{newDesignTranslation.totalAmount}}</strong>
                  </div>
                </li>

                <li *ngIf="status.value" attr.data-testid="li-{{ status.code }}" [ngClass]="{
                  'list-item': true
                }">
                  <div class="list-item__status">
                    <cwc-status-indicator role="status" [variant]="getStatusVariant(status)" size="small"
                      [outline]="status.outline">
                      <span class="list-item__status-label">{{ status.name }}</span>
                    </cwc-status-indicator>
                    <div class="value">
                      {{ status.value }}&nbsp;{{ statusListItemOrdersLabel }}
                    </div>
                    <div class="value" *ngIf="status?.balance" [innerHtml]="status.balance | cmxCurrency">
                    </div>
                  </div>
                  <div class="list-item__total" *ngIf="!isNewDashboard2025Enabled && renderTotals"
                    [innerHTML]="status.formattedTotal">
                  </div>
                </li>
              </ng-container>
            </ul>
          </ng-container>

        </cwc-cell>
        <cwc-cell [rowstart]="tmpState.compactDesign ? 1 : 1" [colspan]="tmpState.compactDesign ? 1 : 2"
          class="chart-content">
          <cmx-donut-chart class="fade-in" [donutTotalLabel]="chartTotalLabel" [data]="chartData$ | async"
            [chartColor]="chartColor$ | async"></cmx-donut-chart>
        </cwc-cell>
        <cwc-cell *ngIf="!isNewDashboard2025Enabled && renderTotals && buttonLabel" colspan="5"
          justify-items="flex-end">
          <a href="/invoices-payments/financial-documents">
            <cwc-button design-version="v2">{{ buttonLabel }}</cwc-button>
          </a>
        </cwc-cell>
        <cwc-cell colspan="5"
          *ngIf="!isNewDashboard2025Enabled && renderRecentOrders && recentOrdersLabels && (recentOrdersData$ | async) && (recentOrdersData$ | async)?.length"
          class="recent-orders">
          <div class="recent-orders__header">
            <h4 class="recent-orders__title">
              {{recentOrdersLabels.title}}
            </h4>
            <a href="/ordersnproduct/app/orders" class="recent-orders__link">
              <cwc-button variant="link">{{recentOrdersLabels.viewAll}}</cwc-button>
            </a>
          </div>
          <div class="recent-orders__carousel">
            <cwc-icon class="recent-orders__control" name="arrow-left-rounded-fill"
              [ngClass]="{'disabled': !activeOrderIndex}" size="1.25rem" (click)="changeOrder(false)"></cwc-icon>
            <div class="recent-orders__order">
              <div class="recent-orders__order-header">
                <cwc-status-indicator class="fade-in"
                  [variant]="(recentOrdersData$ | async)[activeOrderIndex]?.statusColor"
                  [outline]="(recentOrdersData$ | async)[activeOrderIndex]?.statusOutline">
                  <span class="recent-orders__status-label fade-in">{{(recentOrdersData$ |
                    async)[activeOrderIndex]?.statusDesc}}</span>
                </cwc-status-indicator>
                <div class="recent-orders__volume fade-in"
                  *ngIf="(recentOrdersData$ | async)[activeOrderIndex]?.unitCode">
                  <cwc-icon class="recent-orders__volume-icon" name="volume" color="true-blue"></cwc-icon>
                  <div class="recent-orders__volume-quantity">{{(recentOrdersData$ |
                    async)[activeOrderIndex]?.totalQuantity}} {{(recentOrdersData$ |
                    async)[activeOrderIndex]?.unitCode}}</div>
                </div>
              </div>

              <cwc-button class="recent-orders__order-number fade-in" variant="link" size="medium"
                (cwcClick)="navigateToOrderDetail()">{{recentOrdersLabels.order}} #{{(recentOrdersData$ |
                async)[activeOrderIndex]?.orderCode}}</cwc-button>

              <div class="recent-orders__jobsite fade-in">{{(recentOrdersData$ | async)[activeOrderIndex]?.jobsiteCode}}
                - {{(recentOrdersData$ | async)[activeOrderIndex]?.jobsiteDesc}}</div>
            </div>
            <cwc-icon class="recent-orders__control" name="arrow-right-rounded-fill"
              [ngClass]="{'disabled': (activeOrderIndex + 1) === (recentOrdersData$ | async).length}" size="1.25rem"
              (click)="changeOrder(true)"></cwc-icon>
          </div>
          <div class="recent-orders__indicators">
            <div *ngFor="let indicator of (recentOrdersData$ | async); let j = index" class="recent-orders__indicator"
              [ngClass]="{'active': j === activeOrderIndex}"></div>
          </div>
        </cwc-cell>
      </cwc-grid>
      <ng-template #emptyResult>
        <cwc-empty-result icon="information-rounded-fill" variant="flat" class="empty-result fade-in" [ngClass]="{
          'empty-result--with-footer': emptyButtonLabel ? true : false
        }">
          {{ emptyListText }}
        </cwc-empty-result>
        <div class="card-footer" *ngIf="renderTotals && emptyButtonLabel">
          <a href="/invoices-payments/financial-documents?closedView=true">
            <cwc-button variant="support" design-version="v2">{{ emptyButtonLabel
              }}</cwc-button>
          </a>
        </div>
      </ng-template>
    </ng-container>
    <ng-template #loadingState>
      <div class="loader-wrapper"><cwc-loader size="medium"></cwc-loader></div>
    </ng-template>

    <div class="card-footer">
      <ng-content select="[slot='body-footer']"></ng-content>
    </div>
  </ng-container>
</app-dashboard-card>